import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const EditOfferPageContent = lazy(() => import("./EditOfferPageContent"));

function EditOfferPageInternal() {
    return (
        <DefaultPage>
            <EditOfferPageContent />
        </DefaultPage>
    );
}

export const EditOfferPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE, Role.TEMPORARY_WORKER)
)(EditOfferPageInternal);
